import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShoppingBag2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconShoppingBag2"><Path fillRule="evenodd" clipRule="evenodd" d="M8.00155 6C8.00155 3.79086 9.79241 2 12.0015 2C14.2107 2 16.0015 3.79086 16.0015 6V7H18.3595L20.6672 22H3.33594L5.64363 7H8.00155V6ZM10.0015 7H14.0015V6C14.0015 4.89543 13.1061 4 12.0015 4C10.897 4 10.0015 4.89543 10.0015 6V7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShoppingBag2;
